import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dynamic-approval',
  templateUrl: './dynamic-approval.component.html',
  styleUrls: ['./dynamic-approval.component.scss']
})
export class DynamicApprovalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
